import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoadingComponent } from './loading/loading.component';
import { InputFeedbackComponent } from './input-feedback/input-feedback.component';

@NgModule({
  declarations: [LoadingComponent, InputFeedbackComponent],
  imports: [
    CommonModule
  ],
  exports: [LoadingComponent, InputFeedbackComponent]
})
export class ComponentsModule { }
